import { authStoreUserTournamentId } from 'modules/auth/store/selectors';
import { Feature } from 'modules/organizer/domain/interfaces/available-feature';
import organizerRepository from 'modules/organizer/domain/repositories/organizer-repository';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import useIsDev from 'shared/hooks/use-is-dev';

interface useFetchAvailableFeatureProps {
  userTournamentId?: number;
  isEnabled?: boolean;
}

export function useFetchAvailableFeature(props?: useFetchAvailableFeatureProps) {
  const { userTournamentId: extraUserTournamentId, isEnabled = true } = props ?? {};

  const isDev = useIsDev();
  const userTournamentId = useSelector(authStoreUserTournamentId) || extraUserTournamentId;

  const query = useQuery({
    queryKey: ['available-feature', userTournamentId],
    queryFn: () => {
      if (!userTournamentId) return Promise.resolve(null);
      return organizerRepository.fetchAvailableFeature(userTournamentId);
    },
    enabled: !!userTournamentId && isEnabled,
    staleTime: Infinity,
    retry: false,
    refetchOnWindowFocus: false,
  });

  if (isDev) {
    return {
      ...query,
      data: {
        OBS_INTEGRATION: true,
        ACTIVE_CHAMPIONSHIPS: true,
        JOYSTICK: true,
        MEDIA_MANAGER: true,
        TOURNAMENT_ANALYTICS: true,
      } as Feature,
    };
  }

  return query;
}
